(function () {
  var STORAGE_KEY = 'ycj_newsletter_status';
  var DISMISS_DAYS = 10;
  var DELAY_MS = 45000;
  var SCROLL_PCT = 0.60;

  function getStatus() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function setStatus(val) {
    try { localStorage.setItem(STORAGE_KEY, val); } catch (e) {}
  }

  function shouldShow() {
    var status = getStatus();
    if (!status) return true;
    if (status === 'subscribed') return false;
    if (status.indexOf('dismissed:') === 0) {
      var ts = parseInt(status.split(':')[1], 10);
      var days = (Date.now() - ts) / 86400000;
      return days >= DISMISS_DAYS;
    }
    return true;
  }

  function openPopup() {
    var popup = document.getElementById('ycj-newsletter-popup');
    if (!popup || popup.classList.contains('is-open')) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    var input = popup.querySelector('#ycj-newsletter-email');
    if (input) setTimeout(function () { input.focus(); }, 300);
  }

  function closePopup() {
    var popup = document.getElementById('ycj-newsletter-popup');
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  function dismissPopup() {
    setStatus('dismissed:' + Date.now());
    closePopup();
  }

  function initTriggers() {
    if (!shouldShow()) return;

    var triggered = false;
    function trigger() {
      if (triggered) return;
      triggered = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      if (unsubscribeCart) unsubscribeCart();
      openPopup();
    }

    var timer = setTimeout(trigger, DELAY_MS);

    function onScroll() {
      var scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (scrolled >= SCROLL_PCT) trigger();
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    var unsubscribeCart = typeof subscribe === 'function'
      ? subscribe('cart-update', trigger)
      : null;
  }

  function initForm() {
    var form = document.getElementById('ycj-newsletter-form');
    if (!form) return;

    var submitting = false;
    var emailInput = form.querySelector('#ycj-newsletter-email');

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        emailInput.classList.remove('is-error');
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;

      var email = emailInput ? emailInput.value.trim() : '';
      if (!email) {
        if (emailInput) emailInput.classList.add('is-error');
        return;
      }

      submitting = true;
      var btn = form.querySelector('.ycj-newsletter-popup__submit');
      if (btn) btn.disabled = true;

      fetch('/contact', {
        method: 'POST',
        body: new FormData(form),
        redirect: 'manual'
      })
        .then(function () {
          setStatus('subscribed');
          showSuccess();
        })
        .catch(function () {
          setStatus('subscribed');
          showSuccess();
        });
    });
  }

  function showSuccess() {
    var formState = document.getElementById('ycj-newsletter-form-state');
    var successState = document.getElementById('ycj-newsletter-success-state');
    if (formState) formState.classList.add('is-hidden');
    if (successState) successState.classList.remove('is-hidden');
  }

  function initClose() {
    var closeBtn = document.getElementById('ycj-newsletter-close');
    if (closeBtn) closeBtn.addEventListener('click', dismissPopup);

    var popup = document.getElementById('ycj-newsletter-popup');
    if (popup) {
      popup.addEventListener('click', function (e) {
        if (e.target === popup) dismissPopup();
      });
    }

    var successBtn = document.getElementById('ycj-newsletter-success-btn');
    if (successBtn) successBtn.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var popup = document.getElementById('ycj-newsletter-popup');
        if (popup && popup.classList.contains('is-open')) dismissPopup();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initClose();
    initForm();
    initTriggers();
  });
})();
